import React, { useEffect, useState } from 'react'
import Layout from '../components/Layout';
import classes from "./UserBlacklist.module.css";
import { InputNumber } from 'primereact/inputnumber';
import { Button } from 'primereact/button';
import { blacklistMsisdnApi, getBlacklistNumbersApi, unsubMsisdnApi } from '../http/http';
import { useDispatch, useSelector } from 'react-redux';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import moment from "moment-timezone";
import BlacklistConfirmationModal from '../components/BlacklistConfirmationModal';
import { useNavigate } from 'react-router-dom';
import { removeToken } from '../store/slices/tokenSlice';
import { toast } from 'react-toastify';
import Spinner from '../components/Spinner';
import UnsubConfirmationModal from '../components/UnsubConfirmationModal';
import { useTranslation } from 'react-i18next';
import { InputText } from 'primereact/inputtext';

const Unsubscription = () => {
    const [msisdn, setMsisdn] = useState("");
    const { tokenData } = useSelector(state => state?.tokenSlice);
    const [modal, setModal] = useState(false);

    const [loading, setLoading] = useState(true);
    const [unsubLoading, setUnsubLoading] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const unsubMsisdn = async () => {
        try {
            setUnsubLoading(true);
            const response = await unsubMsisdnApi(msisdn, tokenData);
            console.log(response, 'response...');
            setUnsubLoading(false);
            setModal(false);
            setMsisdn("");
            if (response?.data?.result?.status == 0) {
                toast.info(t('unsubscription.notExist'));
            }
            else {
                toast.success(t('unsubscription.success'));
            }
        } catch (error) {
            console.log(error, 'error---');
            setUnsubLoading(false);

            if (error?.response?.status == 403) {
                dispatch(removeToken());
                toast.error(t('common.tokenExpired'));
                navigate('/');
            }
            else {
                toast.error(error?.response?.data?.error?.error || error?.response?.error?.error || error?.response?.error || t('common.somethingWentWrong'));
            }
        }
    }

    return (
        <Layout active={4}>

            <div className={classes.message_container}>
                <p className={classes.message_title}>{t('unsubscription.title')}</p>
            </div>

            <div className={classes.input_container}>
                <InputText
                    value={msisdn}
                    onChange={(e) => setMsisdn(e.target.value)} // Fixed event handler
                    placeholder="Alias(ise2code)"
                />
                <Button label={t('common.confirm')} onClick={() => {
                    if (!msisdn) {
                        return;
                    }
                    setModal(true)
                }
                } />
            </div>

            {modal &&
                <UnsubConfirmationModal setModal={setModal} msisdn={msisdn} unsubMsisdn={unsubMsisdn}
                    unsubLoading={unsubLoading}
                />
            }
        </Layout>
    )
}

export default Unsubscription
